<template>
	<div class="media-item">
		<div class="left">
			<slot></slot>
		</div>

		<div class="right">
			<div class="user-identity">
				<div class="user-identity-container">
					<ProfilePic :user="item.user" size="39px" />
					<div>
						<i18n-t
							v-if="item.meeting"
							keypath="chat_meeting_hosted_by"
							tag="p"
							class="media-username"
							:title="item.user.fullname"
						>
							<template #UserName>
								<UserName :user="item.user" />
							</template>
						</i18n-t>

						<p
							v-if="!item.meeting"
							class="media-username"
							:title="item.user.fullname"
						>
							<UserName :user="item.user" />
						</p>

						<p class="media-datetime">
							<slot name="date">
								{{ createdAt }}
							</slot>
						</p>
					</div>
				</div>

				<div class="auto-left">
					<slot name="replay"></slot>
				</div>

				<DotsMenu localize :items="menuOptions" @select="onMenuItemClick" />
			</div>
		</div>
	</div>
</template>

<script>
import store from '@/store'
import { dateFormat } from '@/helperMethods'
import { DotsMenu, UserName, ProfilePic } from '@/components/common'
import { downloadFile } from '@/helpers/utils'

export default {
	props: {
		item: Object,
		messageId: [String, Number],
	},
	components: { DotsMenu, UserName, ProfilePic },
	data() {
		return {
			store,
		}
	},

	computed: {
		menuOptions() {
			const options = [{ id: 'view', label: 'chat_message_viewinchat' }]
			if (this.item.isFile || this.item.isAudio) {
				options.push({
					id: 'download',
					label: 'admin_reports_status_download',
				})
			}
			return options
		},
		createdAt() {
			return dateFormat(this.item.created_at)
		},
	},

	methods: {
		onMenuItemClick({ id }) {
			switch (id) {
				case 'view':
					return this.viewInChat()
				case 'download':
					const { mediaUrl, title } = this.item
					return downloadFile(mediaUrl, title)
			}
		},

		viewInChat() {
			const { chat, id } = this.$route.params
			this.$router.push({
				name: 'chat',
				params: { chat, id },
				query: { centered: this.messageId },
			})
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.left,
.right {
	width: 50%;
	flex-shrink: 0;
	display: flex;
}

.right {
	border-left: 1px solid #dfe1e3;
	padding: 10px;
}

.media-item {
	display: inline-flex;
	width: 100%;
	margin-bottom: 7px;
	border: 1px solid #dfe1e3;
	border-radius: 8px;
	cursor: pointer;
	&:hover {
		background-color: $light-blue;
	}
}

.user-identity {
	@include flex;
	width: 100%;
}

.user-identity-container {
	@include flex;
	gap: 12px;
}

.media-username {
	font-family: Avenir-Medium;
	font-size: 14px;
	color: #2c2d30;
	margin: 0;
	max-width: 300px;
	display: inline-flex;
	align-items: center;
	gap: 4px;
	white-space: nowrap;
	.user-display-name {
		@include ellipsis;
		flex-grow: 1;
		display: inline-block !important;
	}
}

.media-datetime {
	width: 181px;
	height: 16px;
	font-family: Avenir-Medium;
	font-size: 12px;
	font-weight: 500;
	color: #8a8d93;
	margin: 0;
}

.user-profile-img {
	width: 39px;
	height: 39px;
	margin-right: 10px;
	flex-shrink: 0;
}

.auto-left {
	margin-left: auto;
	align-self: center;
}
</style>

<style lang="scss">
@import 'src/sass/variables';

@include overrideScheme('dark') {
	.media-item {
		border-color: var(--neutral-40040);
		background-color: var(--neutral-0) !important;
		&:hover {
			background-color: $light-blue !important;
		}

		.right {
			border-color: var(--neutral-40040);
			.media-username {
				color: var(--neutral-800);
			}
		}
	}
}
</style>
